import React from 'react';

import classNames from 'classnames';

import TableHeader from '../table-header';
import NoDataMessage from '../no-data-message';
import type { RenderTableContainerProps } from '../../bringg-react-table';
import type { BaseRecord } from '../../types';

const BasicTableContainer = <T extends BaseRecord>(props: RenderTableContainerProps<T>) => {
	const { tableInstance, RenderRow } = props;
	const hasData = tableInstance.rows.length > 0;
	return (
		<>
			<TableHeader headerGroups={tableInstance.headerGroups} />
			<div className={classNames('table-body', { 'no-data': !hasData })}>
				{hasData ? (
					tableInstance.rows.map((row, index) => <RenderRow key={row.id} index={index} />)
				) : (
					<NoDataMessage />
				)}
			</div>
		</>
	);
};

export default BasicTableContainer;
